import { Outlet, ScrollRestoration } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import PromoBanner from '../PromoBanner'
import PromoPopup from '../PromoPopup'

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-effect">
      <PromoBanner />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <PromoPopup />
      <ScrollRestoration />
    </div>
  )
}
